/**
 * Card brand to SVG file mapping utility
 * Maps credit card brand names to their corresponding SVG logo paths
 */

// Import all card brand logos so Vite can process them for production builds
import visaLogo from "@/assets/icons/logos/Visa.svg";
import mastercardLogo from "@/assets/icons/logos/Mastercard.svg";
import amexLogo from "@/assets/icons/logos/american-express.svg";
import isracardLogo from "@/assets/icons/logos/Isracard.svg";
import dinersLogo from "@/assets/icons/logos/Diners.svg";
import genericCardLogo from "@/assets/icons/logos/generic-card.svg";

// Map of supported card brands to their imported SVG paths (lowercase keys for consistent matching)
const cardBrandMap = {
  visa: visaLogo,
  mastercard: mastercardLogo,
  "american express": amexLogo,
  americanexpress: amexLogo,
  amex: amexLogo,
  isracard: isracardLogo,
  diners: dinersLogo,
  "diners club": dinersLogo,
};

// Default icon for unknown brands
const defaultIcon = genericCardLogo;

/**
 * Get the SVG file name for a given card brand
 * @param {string} brand - The card brand name
 * @returns {string} - The SVG file name
 */
export function getCardBrandIcon(brand) {
  if (!brand) {
    return defaultIcon;
  }
  const normalizedBrand = brand.toLowerCase().trim();
  return cardBrandMap[normalizedBrand] || defaultIcon;
}

/**
 * Get the full path to the card brand SVG icon
 * @param {string} brand - The card brand name
 * @returns {string} - The full path to the SVG file
 */
export function getCardBrandIconPath(brand) {
  return getCardBrandIcon(brand);
}

export default {
  getCardBrandIcon,
  getCardBrandIconPath,
};
